<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <div class="ml-10por mb-5por mr-5por">
      <div>
        <b-row>
          <b-col cols="12" md="6" align-self="center">
            <h4 class="encuentra-necesitas ml-3">
              Encuentre rápidamente lo que necesita
            </h4>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="filtro">
              <b-col cols="12" lg="3" align-self="center">
                <h4>Filtrado</h4>
              </b-col>
              <b-col cols="12" lg="9" align-self="center">
                <b-row>
                  <b-col cols="12" md="8">
                    <SelectComponet
                      :data="cargues"
                      v-model="selectInformes"
                    ></SelectComponet>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-button
                      variant="primary"
                      class="btn-buscar"
                      @click="selectInformes = null"
                      >Limpiar</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <template v-for="informe in Informes">
          <b-col cols="12" md="3" :key="informe.id" v-if="informe.visible">
            <div class="ficha">
              <div class="mt-5">
                <b-col>
                  <b-row style="height: 250px !important">
                    <b-col>
                      <br />
                      <h5 class="color-black">{{ informe.titulo }}</h5>
                      <p style="font-size: 12px">{{ informe.texto }}</p>
                    </b-col>
                  </b-row>
                  <b-row style="height: 50px !important">
                    <b-col>
                      <b-button
                        class="button-carga"
                        style="margin: 2%"
                        :to="{ path: '/carga/' + informe.slug }"
                        >Ingresar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <div>
            <b>Nota:</b> le recomendamos realizar el cargue en el siguiente
            orden: (1) Registros Nuevos (2) Novaciones (3) Cartera
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectInformes from "@/data/SelectCargaArchivos.json";

export default {
  name: "CargaArchivos",
  data() {
    return {
      SelectInformes: SelectInformes,
      selectInformes: null,
      cargues: [],
    };
  },
  computed: {
    Informes() {
      let _cargues = this.$store.getters["pages/CargaArchivos"];
      this.cargues = [
        { value: null, text: "Seleccionar cargue", disabled: true },
      ];
      _cargues.forEach((element) => {
        if (element.visible) {
          this.cargues.push({ value: element.titulo, text: element.titulo });
        }
      });
      if (this.selectInformes != null) {
        _cargues = _cargues.filter(
          (informe) => informe.titulo == this.selectInformes
        );
      }
      return _cargues;
    },
    selectFilter() {
      return [...new Set(this.Informes.map((x) => x.titulo))];
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
  },
  created() {
    this.$store.dispatch(
      "pages/setPermisosCargue",
      this.$store.state.user.permisos.find(
        (permiso) => permiso.descripcion == "archivos_cargues_portal"
      )
    );
  },
};
</script>
